// extracted by mini-css-extract-plugin
export default {"base":"SearchInput_base__WpVNK"};